import React from "react"
import { FaEye, FaEyeSlash } from "react-icons/fa"
import { IconButton, InputAdornment, TextField } from "@mui/material"
import { useState } from "react"
import { Mask } from "utils/mask"

export const TextInput: React.FC<{
  onKeyUp?: () => void,
  required: boolean,
  label: string,
  type: string,
  id: string,
  setState?: any,
  state: any,
  name: string,
  mask?: "money" | "cpf_cnpj" | "email" | "phone" | "cep",
  placeholder: string
  error?: string
}> = ({ ...props }) => {
  const { required, label, type, id, setState, state, name, onKeyUp, mask, placeholder, error } = props
  const [showPassword, setShowPassword] = useState(type === "password" ? false : true)
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleChangeMask = (value: string, maskType?: string | undefined) => {
    const maskInstance = new Mask()
    if (!maskType) {
      return value
    }

    if (maskType === "email") {
      return value
    }
    value = value.replace(/\D/g, "")

    if (maskType === "money") {
      return maskInstance.money(value)
    }

    if (maskType === "cpf_cnpj") {
      return maskInstance.cpf_cnpj(value)
    }

    if (maskType === "phone") {
      return maskInstance.phone(value)
    }

    if (maskType === "cep") {
      return maskInstance.cep(value)
    }
    return value
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = event.target.value
    const formattedValue = handleChangeMask(rawValue, mask)

    if (name.includes(".")) {
      const [parent, child] = name.split(".")
      setState({
        ...state,
        [parent]: {
          ...state[parent],
          [child]: formattedValue,
        }
      })
    } else {
      setState({
        ...state,
        [name]: formattedValue
      })
    }
  }

  const getCurrentValue = () => {
    if (name.includes(".")) {
      const [parent, child] = name.split(".")
      return state[parent]?.[child] || ""
    }
    return state[name] || ""
  }

  return (
    <div>
      <label style={{ fontSize: 16, fontWeight: "bold", color: "#332E1A", margin: "0px" }}>
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <br />
      <TextField
        size='medium'
        onKeyUp={onKeyUp && ((e) => e.key === "Enter" ? onKeyUp() : void 0)}
        type={showPassword ? "text" : "password"}
        style={{ backgroundColor: "#EFEFEF", borderRadius: "5px", border: error ? "1px solid #FF0000" : "" }}
        placeholder={placeholder}
        onChange={handleChange}
        value={getCurrentValue()}
        id={id}
        required={required}
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
              {type === "password" && (
                <IconButton onClick={handleClickShowPassword} edge="start">
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </IconButton>
              )}
            </InputAdornment>
          ),
          startAdornment: mask === "money" ? (
            <div style={{ fontWeight: "bold", color: "#555555", backgroundColor: "#EcE7E7", borderRadius: "5px 0px 0px 5px", padding: "12px", borderRight: "1px solid", borderColor: "#332E1A", position: "relative" }}>
              <span>R$</span>
            </div>
          ) : mask === "email" ? (
            <div style={{ fontWeight: "bold", color: "#555555", backgroundColor: "#EcE7E7", borderRadius: "5px 0px 0px 5px", padding: "12px", borderRight: "1px solid", borderColor: "#332E1A", position: "relative" }}>
              <span>@</span>
            </div>
          ) : null,
        }}
        fullWidth
      />
      {error ? <span style={{color: "#FF0000", fontSize:"10px"}}>{error}</span>: ""}
    </div>
  )
}
